import axios from 'axios'

export default function(url) {
  return axios.get(url).then(response => response.data.data)
}



// WEBPACK FOOTER //
// ./D:/node-prj/geoviewer2/src/services/getGasComboConfig.js